import script from "./Languages.vue?vue&type=script&setup=true&lang=js"
export * from "./Languages.vue?vue&type=script&setup=true&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=0a906027&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a906027"]])

export default __exports__